import user from "../../../../../js/user";

export default () => {
  $(document).ready(function ($) {
    initWidget();
  });

  function initWidget() {
    //Comprobamos que existe el widget en la página actual
    let $widget = document.querySelector('.opinary-widget-embed');
    if (!$widget) {
      return;
    }
      //Comprobamos si el usuario esta logado, y si esta logado comprobamos si es partner
      let freeMember = false;
      let paidMember = false;

      if (user.isLogged) {
        freeMember = true;
        if (user.isPartner) {
          freeMember = false;
          paidMember = true;
        }
      }
      let dataAttr = "{freeMember: " + freeMember + ", paidMember: " + paidMember + "}";
      //Añadimos atributo al head
      let $head = document.querySelector("head");
      $head.setAttribute("data-opinary", dataAttr);

  }
}
